module.exports = __webpack_public_path__ + "img/img_left_nav_realtime_hover.cd47d3a0.svg";